const ModuleName = "md_login";

const ModuleDefaults = {
  // options

  // 登入
  whenClickSubmitBtn_login: (e) => {
    // console.log("點了一下一般登入按鈕 ");
  },
  whenClickSubmitBtn_login_IDNumber: (e) => {
    // console.log("點了一下身分證登入按鈕");
  },

  // 註冊
  whenClick_readPolicy: (e) => {
    // console.log("點了一下同意隱私權政策");
  },
  whenClickSubmitBtn_entryRegister: (e) => {
    // console.log("點了一下註冊按鈕");
  },
  whenClickSubmitBtn_validatePage: (e) => {
    // console.log("點了一下發送驗證碼的按鈕");
  },

  whenClickSubmitBtn_modifyRegiterId: (e) => {
    // console.log("點了一下在修改郵件或手機，發送驗證碼的按鈕");
  },

  whenClickSubmitBtn_modifyRegiterIdCode: (e) => {
    // console.log("點了一下在修改郵件或手機，驗證驗證碼的按鈕");
  },

  // 身分證登入後的驗證
  whenClickSubmitBtn_typePhone: (e) => {
    // console.log("點了一下身分證登入之後，申請手機的驗證碼的按鈕");
  },
  whenClickSubmitBtn_typePhoneCode: (e) => {
    // console.log("點了一下身分證登入之後，驗證手機驗證碼的按鈕");
  },
  whenClickSubmitBtn_typeEmail: (e) => {
    // console.log("點了一下身分證登入之後，申請電子郵件的驗證碼的按鈕");
  },
  whenClickSubmitBtn_typeEmailCode: (e) => {
    // console.log("點了一下在登入之後，驗證電子郵件驗證碼的按鈕");
  },

  // 忘記密碼
  whenClickSubmitBtn_forgotpsd_account: (e) => {
    // console.log("點了一下在忘記密碼輸入帳號，申請發送驗證碼的按鈕");
  },

  whenClickSubmitBtn_forgotpsd_typeAccountCode: (e) => {
    // console.log("點了一下在忘記密碼輸入驗證碼，驗證驗證碼");
  },

  whenClickSubmitBtn_forgotpsd_resetPsd: (e) => {
    // console.log("點了一下在忘記密碼驗證完成後，重設新密碼的按鈕");
  },

  whenClickGoToMemberCenter: (e) => {
    // console.log("點了一下在驗證成功前往會員專區的按鈕");
  },
  whenClickGoToLoginPage: (e) => {
    // console.log("點了一下在重設密碼之後，前往登入頁的按鈕");
  },

  // 其他
  whenClickGetNewValidateCode: (e) => {
    // console.log("點了一下，重新發送驗證碼的按鈕");
  },

  whenClickTab: (e) => {
    // console.log("Tab 被點了一下");
  },

  whenCheckboxChecked_rememberMe: (e) => {
    // console.log("登入時，同意記得我");
  },
};

class Module {
  constructor(ele, options) {
    this.ele = ele;
    this.$ele = $(ele);
    this.option = options;

    this.$wantLoginBtn = $(document).find(".loginBtn");
    this.$closeIcon = this.$ele.find(".md_login_closeIcon");
    this.$mainContent = this.$ele.find(".md_login_content");
    this.$tabTilte = this.$ele.find(".md_tab_title");
    this.$tabBox = this.$ele.find(".md_tab_box");
    this.$switchContent = this.$ele.find(".md_tab_content");
    this.countdownPages = [
      "typePhoneCode",
      "typeEmailCode",
      "validatePage",
      "modifyRegisterId_typeValidateCode",
      "forgotpsd_typeValidateCode",
      "forgotpsd_robotValidate",
    ]; // 有倒數的頁面
  }
  init() {
    // 初始化
    this.clickOutsideToClose();
    this.clickLoginBtn();
    this.clickCloseIcon();
    this.clickTabItem();
    this.clickShowPsdIcon();
    this.focusInput();
    this.keyupInput();
    this.keydownChineseInput();
    this.keyEventBirthdayInput();
    this.clickButton();
    this.clickCheckBox();
    this.switchTabById();
    this.registerTriggerOpenEvent();
    this.registerSwitchTabByIdEvent();
    this.registerSwitchContentEvent();
    this.registerTriggerCloseEvent();
    this.changeRadio();
    this.timeCountDown();
    this.scrollEvent();
  }

  // 註冊監聽事件
  clickLoginBtn() {
    // 點擊登入鈕
    const self = this;
    self.$wantLoginBtn.on("click", () => {
      self.open();
      self.switchContent("entry");
    });
  }

  clickOutsideToClose() {
    const self = this;
    self.$ele.on("click", (e) => {
      if ($(e.target).hasClass("md_login_overlay")) {
        self.close();
      }
    });
  }

  clickCloseIcon() {
    const self = this;
    self.$closeIcon.on("click", () => {
      self.close();
    });
  }

  clickTabItem() {
    const self = this;
    self.$tabBox.on("click", (e) => {
      self.switchTab($(e.currentTarget));
    });
  }

  clickShowPsdIcon() {
    const self = this;
    self.$ele.find(".md_input_iconWrap").on("click", (e) => {
      self.togglePassword(e);
    });
  }

  clickCheckBox() {
    const self = this;
    self.$ele.find("input[type='checkbox']").on("click", (e) => {
      self.toggleCheckbox(e);
    });
  }

  focusInput() {
    const self = this;
    self.$ele.find(".md_input input").on("focus", (e) => {
      e.currentTarget.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    });
  }

  keyupInput() {
    const self = this;
    self.$ele.find(".md_input").on("keyup", (e) => {
      self.clearAllError($(e.currentTarget));
    });
  }

  keyEventBirthdayInput() {
    const self = this;
    self.$ele.find("input[data-validate='date']").on("keyup", (e) => {
      self.formatDateInput(e);
    });
    self.$ele.find("input[data-validate='date']").on("keydown", (e) => {
      self.formatDelteDash(e);
      self.onlyTypeNumber(e);
    });
  }

  keydownChineseInput() {
    const self = this;
    let isComposing = false;

    self.$ele
      .find("input[data-validate='chineseName']")
      .on("compositionstart", () => {
        // 開始拼音
        isComposing = true;
      })
      .on("compositionend", (e) => {
        // 拼音結束後
        isComposing = false;
        self.onlyTypeChinese(e);
      })
      .on("input", (e) => {
        // 每次輸入欄位內容改變就會觸發且不是正在拼音
        if (!isComposing) {
          self.onlyTypeChinese(e);
        }
      });
  }

  clickButton() {
    const self = this;

    // entry
    self.$ele.find(".md_login_login_submitbutton").on("click", (e) => {
      // 登入鈕
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_login(e);
      }
    });

    self.$ele.find(".md_login_forgetPsdBtn").on("click", (e) => {
      // 忘記密碼
      e.preventDefault();
      self.switchContent("forgotpsd_account");
    });

    self.$ele.find(".md_login_idNumber").on("click", (e) => {
      // 改用身分證登入
      e.preventDefault();
      self.switchContent("IDNumber");
    });

    self.$ele.find(".md_login_entry_register_submitbutton").on("click", (e) => {
      // 註冊
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_entryRegister(e);
      }
    });

    self.$ele.find(".md_login_register_readPolicy").on("click", (e) => {
      e.preventDefault();
      self.disappearPolicy(e);
      self.option.whenClick_readPolicy(e);
    });

    // 購買的登入註冊
    self.$ele.find(".md_login_chechoutEntry_submitbutton").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_login(e);
      }
    });
    self.$ele.find(".md_login_chechoutEntry_register_submitbutton").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_entryRegister(e);
      }
    });

    // 身分證登入 IDNumber
    self.$ele.find(".md_login_IDNumber_submitbutton").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_login_IDNumber(e);
      }
    });

    self.$ele.find(".md_login_normal").on("click", (e) => {
      // 改用電郵或手機登入
      e.preventDefault();
      self.switchContent("entry");
    });

    self.$ele.find(".md_login_validatePage_register_submitbutton").on("click", (e) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);

      if ($btn.text().trim() === "重新發送") {
        self.option.whenClickGetNewValidateCode(e);
        self.getNewValidateCode();
        return;
      }

      if ($btn.text().trim() === "驗證" && self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_validatePage(e);
      }
    });

    self.$ele.find(".md_login_buttomLineRight").on("click", (e) => {
      //修改註冊的帳號
      self.switchContent("modifyRegisterId");
    });

    self.$ele.find(".md_login_modifyRegiterId_submitbutton").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_modifyRegiterId(e);
      }
    });

    self.$ele
      .find(".md_login_modifyRegisterId_typeValidateCode_editor")
      .on("click", (e) => {
        // 編輯
        e.preventDefault();
        self.switchContent("modifyRegisterId");
      });

    self.$ele
      .find(".md_login_modifyRegisterId_typeValidateCode_submitbutton")
      .on("click", (e) => {
        // 驗證 驗證碼
        e.preventDefault();
        const $btn = $(e.currentTarget);

        if ($btn.text().trim() === "重新發送") {
          self.option.whenClickGetNewValidateCode(e);
          self.getNewValidateCode();
          return;
        }

        if ($btn.text().trim() === "驗證" && self.trimValidate(e)) {
          self.option.whenClickSubmitBtn_modifyRegiterIdCode(e);
        }
      });

    self.$ele.find(".md_login_registerSuccess_submitbutton").on("click", (e) => {
      e.preventDefault();
      self.option.whenClickGoToMemberCenter(e);
    });

    // 身分證登入 驗證手機
    self.$ele.find(".md_login_typephone_submitbutton").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_typePhone(e);
      }
    });

    self.$ele.find(".md_login_typephoneCode_submitbutton").on("click", (e) => {
      // 驗證 驗證碼
      e.preventDefault();
      const $btn = $(e.currentTarget);

      if ($btn.text().trim() === "重新發送") {
        self.option.whenClickGetNewValidateCode(e);
        self.getNewValidateCode();
        return;
      }

      if ($btn.text().trim() === "驗證" && self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_typePhoneCode(e);
      }
    });

    self.$ele.find(".md_login_typeEmail_submitbutton").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_typeEmail(e);
      }
    });

    self.$ele.find(".md_login_typePhoneCode_other").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.switchContent("typePhone");
      }
    });

    self.$ele.find(".md_login_typeEmailCode_submitbutton").on("click", (e) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);

      if ($btn.text().trim() === "重新發送") {
        self.option.whenClickGetNewValidateCode(e);
        self.getNewValidateCode();
        return;
      }

      if ($btn.text().trim() === "驗證" && self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_typeEmailCode(e);
      }
    });

    self.$ele.find(".md_login_typeEmailCode_other").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.switchContent("typeEmail");
      }
    });

    // 忘記密碼
    self.$ele.find(".md_login_forgotpsd_account_submitbutton").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_forgotpsd_account(e);
      }
    });

    self.$ele.find(".md_login_forgotpsd_typeValidateCode_editor").on("click", (e) => {
      e.preventDefault();
      self.switchContent("forgotpsd_account");
    });

    self.$ele
      .find(".md_login_forgotpsd_typeValidateCode_submitbutton")
      .on("click", (e) => {
        e.preventDefault();
        const $btn = $(e.currentTarget);

        if ($btn.text().trim() === "重新發送") {
          self.option.whenClickGetNewValidateCode(e);
          self.getNewValidateCode();
          return;
        }

        if ($btn.text().trim() === "驗證" && self.trimValidate(e)) {
          self.option.whenClickSubmitBtn_forgotpsd_typeAccountCode(e);
        }
      });

    self.$ele.find(".md_login_forgotPsd_gotoRigister_text").on("click", (e) => {
      e.preventDefault();
      self.switchContent("entry", "switch_register");
    });

    self.$ele.find(".md_login_resetPsd_submitbutton").on("click", (e) => {
      e.preventDefault();
      if (self.trimValidate(e)) {
        self.option.whenClickSubmitBtn_forgotpsd_resetPsd(e);
      }
    });

    self.$ele.find(".md_login_psdResetSuccess_submitbutton").on("click", (e) => {
      e.preventDefault();
      // 前往登入頁
      self.option.whenClickGoToLoginPage(e);
    });

    self.$ele.find(".md_login_closeLoginModal").on("click", (e) => {
      e.preventDefault();
      self.close();
    });
  }

  changeRadio() {
    const self = this;
    $(".md_login_radioLabel").on("change", (e) => {
      self.toggleRadio(e);
    });
  }

  scrollEvent() {
    const self = this;
    self.$ele.find(".md_login_policyContent").on("scroll", (e) => {
      self.scrollToBottom(e);
    });
  }

  // 方法
  open() {
    const self = this;
    self.$ele.css("display", "block");
    $("body").css("overflow", "hidden");
  }

  close() {
    const self = this;
    self.$ele.css("display", "none");
    $("body").css("overflow", "");
  }

  switchContent(contentId, tabId) {
    const self = this;
    const $targetContent = self.$ele.find(
      `.md_login_content[data-content="${contentId}"]`,
    );
    const $firstTabBox = $targetContent.find(".md_tab_box").first();
    const tabFirstId = $firstTabBox.find(".md_tab_title").data("target");
    self.clearAllError($targetContent);

    self.$ele.find(".md_login_content").removeClass("active");
    self.$ele.find(".md_tab_box").removeClass("active");
    self.$ele.find(".md_tab_content").removeClass("active");
    self.$ele.find(".md_login_idNumber_otherway").addClass("md_login_hide");
    $targetContent.addClass("active");

    const $animatedTabContents = $targetContent.find(".md_tab_content"); // tab 內容動畫

    if (tabId) {
      self.switchTabById(tabId);
    } else if ($firstTabBox.length && tabFirstId) {
      // 預設選第一個 tab
      $firstTabBox.addClass("active");
      $targetContent.find(`#${tabFirstId}`).addClass("active");

      $animatedTabContents.addClass("md_login_FadeIn");
      setTimeout(() => {
        $animatedTabContents.removeClass("md_login_FadeIn");
      }, 300);
    } else if ($firstTabBox.length === 0) {
      $targetContent.addClass("md_login_FadeIn");
      setTimeout(() => {
        $targetContent.removeClass("md_login_FadeIn");
      }, 300);
    }

    $animatedTabContents.addClass("md_login_FadeIn");
    setTimeout(() => {
      $animatedTabContents.removeClass("md_login_FadeIn");
    }, 300);

    if (self.countdownPages.includes(contentId)) {
      self.getNewValidateCode();
    }
  }

  switchTab(e) {
    // 切 tab
    const self = this;
    const $targetBox = $(e);
    const targetId = $targetBox.find(".md_tab_title").data("target");
    const $currentContent = self.$ele.find(".md_login_content.active");
    const $targetTabContent = $currentContent.find(`#${targetId}`);

    // 移除所有 tab 跟 tab-content 的 ACTIVE
    self.$tabBox.removeClass("active");
    self.$switchContent.removeClass("active");
    self.clearAllError($currentContent);

    // 在目前的 login_content下，在tab中加上active
    $targetBox.addClass("active");
    $targetTabContent.addClass("active");

    const currentIndex = $currentContent.find(".md_tab_box").index($targetBox);

    $targetTabContent.addClass("md_login_FadeIn");
    setTimeout(() => {
      $targetTabContent.removeClass("md_login_FadeIn");
    }, 300);
    self.option.whenClickTab(e, targetId, currentIndex);
  }

  switchTabById(tabId) {
    const self = this;
    const $currentContentBox = self.$ele.find(".md_login_content.active");

    const $targetBox = $currentContentBox.find(".md_tab_box").filter(function () {
      return $(this).find(".md_tab_title").data("target") === tabId;
    });

    if ($targetBox.length) {
      self.switchTab($targetBox);
    }
  }

  togglePassword(e) {
    const $iconBlock = $(e.currentTarget);
    const $inputWrap = $iconBlock.closest(".md_input_input_wrap");
    const $passwordInput = $inputWrap.find("input");
    const $hidePsdIcon = $inputWrap.find(".md_login_hidePasswordIcon");
    const $showPsdIcon = $inputWrap.find(".md_login_showPasswordIcon");

    const isPassword = $passwordInput.attr("type") === "password";
    const hideClass = "md_login_hide";

    $hidePsdIcon.toggleClass(hideClass, isPassword);
    $showPsdIcon.toggleClass(hideClass, !isPassword);
    $passwordInput.attr("type", isPassword ? "text" : "password");
  }

  toggleCheckbox(e) {
    const self = this;
    const $iconBlock = $(e.currentTarget);
    const $checkboxBlock = $iconBlock.closest(".md_checkbox");
    const $checkboxIcon = $checkboxBlock.find(".md_icon");
    const $checkboxInput = $checkboxBlock.find("input[type='checkbox']");

    const hideClass = "md_login_hide";

    if ($checkboxInput.prop("checked")) {
      $checkboxIcon.removeClass(hideClass);
      if ($checkboxInput.attr("name") === "rememberMe") {
        self.option.whenCheckboxChecked_rememberMe(e);
      }
    } else {
      $checkboxIcon.addClass(hideClass);
    }
  }

  toggleRadio(e) {
    const self = this;
    const $targetRadioItem = $(e.currentTarget);
    const $currentContent = self.$ele.find(".md_login_content.active");
    const $input = $currentContent.find(".md_login_emailOrPhone");
    const $inputBlock = $input.closest(".md_input");
    const selected = $currentContent.find("input[type='radio']:checked").val();
    const isDisabled = $targetRadioItem.attr("disabled");

    if (isDisabled !== undefined) return;

    if (selected === "phone") {
      $input.attr("type", "tel");
      $input.attr("placeholder", "請輸入手機號碼");
      $input.data("validate", "phone");
      $input.data("pattern-errormessage", "請輸入正確的手機號碼格式");
    } else if (selected === "email") {
      $input.attr("type", "email");
      $input.attr("placeholder", "請輸入電子郵件");
      $input.data("validate", "email");
      $input.data("pattern-errormessage", "請輸入正確的電子郵件格式");
    }

    self.clearAllError($inputBlock);
  }

  scrollToBottom(e) {
    const $box = $(e.currentTarget);
    const $content = $box.closest(".md_login_content.active");
    const $policyBtn = $content.find(".md_login_register_readPolicy");

    const $boxHeight = $box.scrollTop() + $box.innerHeight();
    const $scrollHeight = $box[0].scrollHeight;

    if ($boxHeight >= $scrollHeight - 1) {
      $policyBtn.removeClass("md_button_disableBtn");
      $policyBtn.addClass("md_button_primary").removeAttr("disabled");
    }
  }

  // 隱私權政策
  disappearPolicy(e) {
    const $button = $(e.currentTarget);
    const $content = $button.closest(".md_login_content.active");

    $content.find(".md_login_registerArea").removeClass("md_login_hide");
    $content.find(".md_tab_content").removeAttr("style");
    $button.addClass("md_login_hide");
    $content.find(".md_login_policyContent").addClass("md_login_hide");
    $content.find("input[name='agreePolicy']").attr("value", "true");
  }

  // 欄位驗證
  trimValidate(e) {
    const $button = $(e.currentTarget);
    const $form = $button.closest("form");
    const $content = $button.closest(".md_login_content.active");
    const $otherWay = $content.find(".md_login_idNumber_otherway");
    let isValid = true;
    let passwordValue = "";

    $form.find(".md_input").each((index, ele) => {
      const $ele = $(ele);
      const $input = $ele.find("input");
      const $inputType = $input.data("validate");
      const $inputWrap = $ele.find(".md_input_input_wrap");
      const $inputError = $ele.find(".md_input_errormsg");
      const errorMessage_req = $input.data("req-errormessage");
      const errorMessage_pattern = $input.data("pattern-errormessage");
      const validateRules = {
        chineseName: /^[\u4e00-\u9fa5]+$/,
        date: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
        password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
        email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        phone: /^09\d{8}$/,
        idNumber: /^[A-Z][12]\d{8}$/,
        verificationCode:
          /^(?=(?:[^A-Z]*[A-Z]){2}[^A-Z]*$)(?=(?:\D*\d){4}\D*$)[A-Z\d]{6}$/,
      };

      if ($inputType === "name") {
        if (!validateRules.chineseName.test($input.val())) {
          isValid = false;
          $inputWrap.addClass("error");
          $inputError.addClass("error").text(errorMessage_pattern);
        }
      }

      if ($inputType === "date") {
        if (!validateRules.date.test($input.val())) {
          isValid = false;
          $inputWrap.addClass("error");
          $inputError.addClass("error").text(errorMessage_pattern);
        }
      }

      if ($inputType === "verificationCode") {
        if (!validateRules.verificationCode.test($input.val())) {
          isValid = false;
          $inputWrap.addClass("error");
          $inputError.addClass("error").text(errorMessage_pattern);
        }

        if ($otherWay.length) {
          $otherWay.removeClass("md_login_hide");
        }
      }

      if ($inputType === "email") {
        if (!validateRules.email.test($input.val())) {
          isValid = false;
          $inputWrap.addClass("error");
          $inputError.addClass("error").text(errorMessage_pattern);
        }
      }

      if ($inputType === "phone") {
        if (!validateRules.phone.test($input.val())) {
          isValid = false;
          $inputWrap.addClass("error");
          $inputError.addClass("error").text(errorMessage_pattern);
        }
      }

      if ($inputType === "idNumber") {
        if (!validateRules.idNumber.test($input.val())) {
          isValid = false;
          $inputWrap.addClass("error");
          $inputError.addClass("error").text(errorMessage_pattern);
        }
      }

      if ($inputType === "emailOrPhone") {
        if (
          !validateRules.email.test($input.val()) &&
          !validateRules.phone.test($input.val())
        ) {
          isValid = false;
          $inputWrap.addClass("error");
          $inputError.addClass("error").text(errorMessage_pattern);
        }
      }

      if ($inputType === "password") {
        passwordValue = $input.val();
      }

      if ($inputType === "passwordCheck") {
        if ($input.val() !== passwordValue) {
          isValid = false;
          $inputWrap.addClass("error");
          $inputError.addClass("error").text("兩次輸入的密碼不一致");
        }
      }

      if ($inputType === "password" || $inputType === "passwordCheck") {
        if (!validateRules.password.test($input.val())) {
          isValid = false;
          $inputWrap.addClass("error");
          $inputError.addClass("error").text(errorMessage_pattern);
        }
      }

      if (!$input.val().trim()) {
        isValid = false;
        $inputWrap.addClass("error");
        $inputError.addClass("error").text(errorMessage_req);
      }
    });

    // 同意政策checkbox
    if (
      $form.attr("id") === "entry_register" ||
      $form.attr("id") === "idNumber_register" ||
      $form.attr("id") === "chechoutEntry_register"
    ) {
      if ($form.find("input[name='agreePolicy']").val() !== "true") {
        isValid = false;
      }
    }

    return isValid;
  }

  clearAllError($container) {
    $container.find(".error").removeClass("error");
  }

  onlyTypeChinese(e) {
    const chineseNameRule = /[^\u4e00-\u9fa5]/g;
    const $input = $(e.currentTarget);
    const value = $input.val();

    const cleaned = value.replace(chineseNameRule, "");

    if ($input.val() !== cleaned) {
      $input.val(cleaned);
    }
  }

  onlyTypeNumber(e) {
    const NumberRule = /^\d$/;
    if (!NumberRule.test(e.key) && e.key.length === 1) {
      e.preventDefault();
    }
  }

  // 生日增加 -
  formatDateInput(e) {
    const $input = $(e.target);

    if ($input.data("validate") === "date") {
      let value = $input.val().replace(/[^0-9]/g, "");

      if (value.length > 3) {
        value = value.substring(0, 4) + "-" + value.substring(4);
      }
      if (value.length > 6) {
        value = value.substring(0, 7) + "-" + value.substring(7);
      }
      if (value.length > 10) {
        value = value.substring(0, 10);
      }
      $input.val(value);
    }
  }

  // 生日刪除-
  formatDelteDash(e) {
    const $input = $(e.target);
    if ($input.data("validate") === "date") {
      let value = $input.val();
      if (e.key === "Backspace") {
        if (value.length === 8 && value.charAt(7) === "-") {
          value = value.substring(0, 7);
        } else if (value.length === 5 && value.charAt(4) === "-") {
          value = value.substring(0, 4);
        }
        $input.val(value);
      }
    }
  }

  getCountDownElements() {
    const self = this;
    const $currentContent = self.$ele.find(".md_login_content.active");
    const $form = $currentContent.find("form");
    const $secondsBlock = $currentContent.find(".md_login_timeCountDown");
    const $button = $secondsBlock.closest("form").find(".md_login_timeCountDownBtn");
    const $inpuBlock = $currentContent.find(".md_login_validateInput");
    const $input = $inpuBlock.find("input");
    const $inputWrap = $inpuBlock.find(".md_input_input_wrap");
    const $countDownNumber = $secondsBlock
      .closest("form")
      .find(".md_login_timeCountDown");
    const $countDownText = $secondsBlock
      .closest("form")
      .find(".md_login_timeCountDownText");

    return {
      $form,
      $secondsBlock,
      $button,
      $inpuBlock,
      $input,
      $inputWrap,
      $countDownNumber,
      $countDownText,
    };
  }

  timeCountDown() {
    const self = this;
    const $currentContent = self.$ele.find(".md_login_content.active");
    const currentPage = $currentContent.data("content");
    if (!self.countdownPages.includes(currentPage)) return;

    const {
      $button,
      $inpuBlock,
      $input,
      $inputWrap,
      $countDownNumber,
      $countDownText,
      $secondsBlock,
    } = self.getCountDownElements();

    let countdownTime = parseInt($countDownNumber.data("countdown"));
    $secondsBlock.text(countdownTime);

    if (self.clock) {
      clearInterval(self.clock);
      $input.val("");
    }

    self.clock = setInterval(() => {
      countdownTime--;
      if (countdownTime < 0) {
        $button.text("重新發送");
        clearInterval(self.clock);
        self.clearAllError($inpuBlock);
        $input.attr("disabled", true);
        $inputWrap.css("background-color", "#e5e7eb");
        $input.css("background-color", "#e5e7eb");
        $input.attr("placeholder", "點選重新發送");
        $input.val("");
        $countDownNumber.addClass("md_login_hide");
        $countDownText.text("請取得新的驗證碼");
      } else {
        $secondsBlock.text(countdownTime);
      }
    }, 1000);
  }

  getNewValidateCode() {
    const self = this;
    const $currentContent = self.$ele.find(".md_login_content.active");
    const currentPage = $currentContent.data("content");
    if (!self.countdownPages.includes(currentPage)) return;

    const { $button, $input, $inputWrap, $countDownNumber, $countDownText } =
      self.getCountDownElements();

    $button.text("驗證");
    $input.attr("disabled", false);
    $inputWrap.css("background-color", "#fff");
    $input.css("background-color", "#fff");
    $input.attr("placeholder", "輸入驗證碼");
    $countDownNumber.removeClass("md_login_hide");
    $countDownText.text("秒後可重新發送");
    self.timeCountDown();
  }

  // 註冊 trigger 用
  registerTriggerCloseEvent() {
    const self = this;
    self.$ele.on("closeLoginModal", () => {
      self.close();
    });
  }

  registerTriggerOpenEvent() {
    const self = this;
    self.$ele.on("openLoginModal", (e, ...args) => {
      const [contentId = "entry", tabId] = args;
      self.open(); // 顯示 modal
      self.switchContent(contentId, tabId);
      // 使用方式：$(".md_login").trigger("openLoginModal");  // 預設是 entry
      // 使用方式: $(".md_login").trigger("openLoginModal", ["validatePage", "switch_register"]);
    });
  }

  registerSwitchTabByIdEvent() {
    let self = this;
    self.$ele.on("switchTab", (e, tabId) => {
      return self.switchTabById(tabId);
    });
    // 使用方式：$(".md_login").trigger("switchTab", "switch_register");
  }

  registerSwitchContentEvent() {
    const self = this;
    self.$ele.on("switchContent", (e, ...args) => {
      const [contentId, tabId] = args;
      self.switchContent(contentId, tabId);
    });
    // 使用方式：$(".md_login").trigger("switchContent", "validatePage");
    // 使用方式: $(".md_login").trigger("switchContent", ["validatePage", "switch_register"]);
  }
}

$.fn[ModuleName] = function (options) {
  return this.each(function () {
    var $this = $(this);
    var module = $this.data(ModuleName);
    var opts = null;
    if (module) {
      if (typeof options === "string") {
        module[options]();
      } else {
        throw "unsupported options!";
      }
    } else {
      opts = $.extend({}, ModuleDefaults, typeof options === "object" && options);
      module = new Module(this, opts);
      $this.data(ModuleName, module);
      module.init();
    }
  });
};
